import { string } from 'yup';

enum EMAIL_ERROR {
  INVALID = 'Email address is invalid.',
  REQUIRED = 'Email is required.',
}

const emailSchema = string()
  .trim()
  .transform((v) => (!v ? undefined : v))
  .email();

enum USERNAME_ERROR {
  TOO_SHORT = 'Username must be at least 3 characters.',
  TOO_LONG = 'Username must be 20 characters or fewer.',
  INVALID_CHARACTERS = 'Username contains invalid characters.',
  TAKEN = 'Username is already taken.',
  REQUIRED = 'Username is required.',
}

const usernameSchema = string()
  .trim()
  .transform((v) => (!v ? undefined : v))
  .min(3, USERNAME_ERROR.TOO_SHORT)
  .max(20, USERNAME_ERROR.TOO_LONG)
  .test('allowed-characters', USERNAME_ERROR.INVALID_CHARACTERS, (value) => {
    if (!value) return true;

    return /^[0-9A-Za-z_.\s-]+$/.test(value ?? '');
  });

enum PASSWORD_ERROR {
  TOO_SHORT = 'Password must be at least 8 characters.',
  INVALID_CHARACTERS = 'Password contains invalid characters.',
  MISSING_UPPERCASE = 'Password must contain at least one uppercase letter.',
  MISSING_LOWERCASE = 'Password must contain at least one lowercase letter.',
  MISSING_NUMBER = 'Password must contain at least one number.',
  NOT_MATCHING = 'Passwords do not match.',
  REQUIRED = 'Password is required.',
}

const passwordSchema = string()
  .trim()
  .transform((v) => (!v ? undefined : v))
  .min(8, PASSWORD_ERROR.TOO_SHORT)
  .test('allowed-characters', PASSWORD_ERROR.INVALID_CHARACTERS, (value) => {
    if (!value) return true;

    return /^[A-Za-z0-9!@#%^*()_+\-=[\]{}:,.?/]+$/.test(value ?? '');
  })
  .matches(/[A-Z]/, PASSWORD_ERROR.MISSING_UPPERCASE)
  .matches(/[a-z]/, PASSWORD_ERROR.MISSING_LOWERCASE)
  .matches(/[0-9]/, PASSWORD_ERROR.MISSING_NUMBER);

export {
  EMAIL_ERROR,
  emailSchema,
  PASSWORD_ERROR,
  passwordSchema,
  USERNAME_ERROR,
  usernameSchema,
};
